import { Head } from "@inertiajs/react"

import { MainContainer } from "@/components/ui/container"
import { StaffLayout } from "@/components/layouts/staff-layout"
import { BranchRoster, type Branch } from "@/features/staff/organization/branch-roster"
import { OrganizationWorkspaceNav } from "@/features/staff/organization/workspace-nav"
import { t } from "@/lib/i18n"

/**
 * What the group is made of.
 *
 * Its own tab, beside the comparison rather than above it. The two answer
 * different questions and only one is a reading of a period: this list is true
 * whether or not anybody sold anything, while the comparison is empty until two
 * branches have traded. Sharing a screen left this list sitting under period
 * chips that did not govern it.
 */

type Props = {
  organization: { id: number; name: string }
  canManageOrganization: boolean
  branches: Branch[]
  memberCount: number
  canAddBranch: boolean
}

export default function StaffLocationOrganizationBranches({
  organization,
  canManageOrganization,
  branches,
  memberCount,
  canAddBranch,
}: Props) {
  const title = t("ui.react.pages.staff.location.organization.branches.page_title")

  return (
    <>
      <Head title={`${title} · ${organization.name}`} />

      <MainContainer size="md">
        <OrganizationWorkspaceNav
          current="branches"
          organizationName={organization.name}
          canManageOrganization={canManageOrganization}
        />

        <BranchRoster
          branches={branches}
          memberCount={memberCount}
          organizationId={organization.id}
          canAddBranch={canAddBranch}
        />
      </MainContainer>
    </>
  )
}


StaffLocationOrganizationBranches.layout = (page: React.ReactNode) => <StaffLayout>{page}</StaffLayout>
